const formatter = new Intl.NumberFormat('en', {
    notation: 'compact',
    maximumSignificantDigits: 2,
});

/**
 * Formats a number with compact notation (e.g., 1.5K, 15K, 1.5M).
 * Uses 2 significant digits for consistent display.
 * Returns '-' for null/undefined values.
 */
export function formatCompactNumber(value: number | null | undefined): string {
    if (value == null) {
        return '-';
    }

    return formatter.format(value);
}
